import { useQuery } from "hooks/useQuery";
import { getAllocationPositionV2 } from "features/Dashboard/service";

export const useAllocationData = (brokerAccountId) => {
  const { isLoading, data } = useQuery({
    key: "allocationData",
    queryKey: ["allocationData", brokerAccountId],
    queryFn: async () => {
      const params = {
        broker_account_id: brokerAccountId,
      };
      const response = await getAllocationPositionV2(params);
      return response;
    },
  });

  return {
    isLoading,
    allocationData: data,
    positionData: data?.position_chart || [],
    sectorData: data?.sector_chart || [],
  };
};
